/**
 * Uses the prefers-reduced-motion CSS media feature to detect if the user has requested that the system should
 * minimize the amount of non-essential motion (system-setting e.g. "Show animations in Windows" on/off).
 * See: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 * @returns {boolean} - true, if the user prefers reduced motion, else false.
 */
var preferReducedMotion = function preferReducedMotion() {
  var mediaQueryList = window.matchMedia("(prefers-reduced-motion: no-preference)");
  var preferReduced = !mediaQueryList.matches;
  // console.log(`preferReducedMotion: ${preferReduced}`);
  return preferReduced;
};

export { preferReducedMotion };
